import './App.css';

import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';

// Custom Tags import
import ContenIndex from './CustomElements/ContentIndex';
import ScrollTop from './CustomElements/ScrollTop';
import ScrollBottom from './CustomElements/ScrollBottom';
import { MathSection, LogicalSection, ComputerSection, EnglishSection } from './CustomElements/Sections';
import { SubmitButton, SummaryTable } from './CustomElements/ScoreCard';



class App extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showScore: 'hidden',
    };

    this.handler = this.handler.bind(this);
  }

  handler() {
    this.setState({ showScore: 'visible' });
  }

  render() {
    // console.log("rendered");
    return (
      <div className="App">
        <main>
          <Container>
            <h1 className="text-center site-heading">
              <a href='/' style={{ 'textDecoration': 'none', 'color': 'black' }}>NIMCET 2022 Key Analysis and Marks Calculator</a>
            </h1>
            <span>
              Select the appropriate option for each individual question and then click the <strong>Submit</strong> button to display sectional summary and total marks.
            </span>

            <ContenIndex /> {/* Renders Table of Contents */}

            <MathSection />     {/* Renders Math section */}
            <LogicalSection />  {/* Renders Logical section */}
            <ComputerSection /> {/* Renders Computer section */}
            <EnglishSection />  {/* Renders English section */}

            <SummaryTable display={this.state.showScore} handler={this.handler} />
          </Container>
        </main >
        <ScrollBottom />
        <ScrollTop />
      </div >
    );
  }
}

export default App;
